var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 8,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 8,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 8,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 8,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 8,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 30,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 30,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 30,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 30,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 30,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 52,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 52,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 52,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 52,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 52,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 74,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 74,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 74,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 74,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 74,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 96,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 96,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 96,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 96,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 96,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 118,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 118,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 118,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 118,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 118,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 118,
    r: 8,
    fill: "#6A6D9E",
    fillOpacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBg);
export default __webpack_public_path__ + "static/media/circleBg.b225a2969c7c7f1cb7b88c00aaad1334.svg";
export { ForwardRef as ReactComponent };